/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'
import React from 'react'
import { Loading, show, cleanObject, arrayFrom, showModal } from '../../twd'
import useSavedSearches from './use-saved-searches'

export default ({dataName='saved-searches', maxLength=25} = {}) => {

    const { status, savedSearches } = useSavedSearches()

    return <React.Fragment>
        <div className="vertical-offset-sm"></div>
        <div data-name={dataName} className="container vertical-offset-sm" css={sectionCss}>
            <div className="row vertical-offset-sm"></div>

            <div className="row">
                <div className="col-md-6 col-xs-6">
                <h6 className="sub-head">Saved Searches</h6>
                </div>
                <div className="col-md-6 col-xs-6 text-right">
                <button
                    data-name={dataName + '-manage-link'}
                    className="link-button"
                    onClick={(e) => {
                        showModal({
                            view: 'manage-saved-searches',
                            source: e.target 
                        })
                    }}
                >Manage</button>
                </div>
            </div>

            <div className="row vertical-offset-xs">
            <div className="col-xs-12 text-truncate">
            <Loading status={status}>
            {
                arrayFrom(savedSearches)
                .slice(0,maxLength)
                .map( (a,i) => (
                    <React.Fragment key={i}>
                    <div
                        data-name={dataName + '-row'}
                        className="link-button text-truncate vertical-offset-xs"
                        style={{display:'block'}}
                        item={a}
                        onClick={() => onSearch(a)}>
                        {a.description}
                    </div>
                    </React.Fragment>
                ))
            }
            </Loading>
            </div>
            </div>

        </div>
        </React.Fragment>
}

const onSearch = ({id, searchParams}) => {
    let sp = Object.assign({savedQueryId:id}, searchParams, {persistToPreviousSearches: false})
    show('offerings', Object.assign({
        searchParams: cleanObject(sp),
        _ts: Date.now(),
        from: 'advanced-screener'
    }))
}



// WEBPACK FOOTER //
// ./src/advanced-screener/saved-searches/saved-searches.js